import React, { Component } from "react";

import { compose } from 'redux'

import { connect } from 'react-redux'

import {
  Drawer,
  Toolbar,
  Box,
  List,
  SvgIcon,
  Hidden,
  Divider,
} from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";

import {
  toggleSidebar,
  selectNavigationSidebarOpen,
  selectCurrentSeason,
} from './navigationSlice';

import SeasonSelector from "./SeasonSelector";

import routes, {
  HOME,
  STANDINGS,
  SEASONS,
  FAQS,
} from "../../data/routes";

import SidebarLink from "../../components/SidebarLink";

const drawerWidth = 240;

const styles = (theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    border: 0,
  },
  drawerContainer: {
    overflow: 'auto',
  },
});

const routesBySeasonId = {
  "2022": [
    routes[STANDINGS],
    routes[FAQS],
  ],
  "2023": [
    routes[STANDINGS],
    routes[FAQS],
  ],
  "2024": [
    routes[STANDINGS],
    routes[FAQS],
  ],
  "2025": [
    routes[STANDINGS],
    routes[FAQS],
  ],
  "2026": [
    routes[STANDINGS],
    routes[FAQS],
  ],
};

class Sidebar extends Component {
  toggleDrawer = (open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    this.props.dispatch(toggleSidebar())
  };

  render() {
    // Styling
    const {
      classes,
      user,
      sidebarOpen,
      currentSeason,
    } = this.props;

    const baseUrl = routes[SEASONS].pathWithoutParam + currentSeason;

    return (
      <Box>
        {/* <Hidden xlDown>
          <Drawer
            className={classes.drawer}
            variant="permanent"
            classes={{
              paper: classes.drawerPaper,
            }} 
          >
            <Toolbar />
            <Box >
              <SeasonSelector />
            </Box>
            <Box mr={2} className={classes.drawerContainer}>
              <List>
                {(routesBySeasonId[currentSeason] || []).map((route) => (
                  <SidebarLink
                    key={route.name}
                    baseUrl={baseUrl}
                    routeData={route}
                  />
                ))}
              </List>
            </Box>
          </Drawer>
        </Hidden> */}
        {/* <Hidden xlUp> */}
          <Drawer
            variant="temporary"
            classes={{
              paper: classes.drawerPaper,
            }} 
            open={sidebarOpen}
            onClose={this.toggleDrawer()}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <Toolbar disableGutters>
              <Box width="100%">
                <SeasonSelector />
              </Box>
            </Toolbar>
            <Divider />
            <Box
              mr={2}
              className={classes.drawerContainer}
              onClick={this.toggleDrawer()}
              onKeyDown={this.toggleDrawer()}
            >
              <List>
                {(routesBySeasonId[currentSeason] || []).map((route) => (
                  <SidebarLink
                    key={route.name}
                    baseUrl={baseUrl}
                    routeData={route}
                  />
                ))}
              </List>
            </Box>
          </Drawer>
        {/* </Hidden> */}
      </Box>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    sidebarOpen: selectNavigationSidebarOpen(state),
    currentSeason: selectCurrentSeason(state),
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(Sidebar);
